export const validateNumber = (value: string)=> parseInt(value, 10) || 0;
